/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

document.addEventListener('DOMContentLoaded', () => {
  const buttons = document.querySelectorAll('button');

  buttons.forEach((button) => {
      const priceElement = button.querySelector('[data-product-price]');
      
      if (priceElement) {
          // Function to check and hide the span
          const checkAndHide = () => {
              if (button.classList.contains('is-loading') || button.classList.contains('is-added')) {
                  priceElement.style.display = 'none';
              } else {
                  priceElement.style.display = ''; // Reset to default display
              }
          };

          // Create a MutationObserver to watch for class changes on the button
          const observer = new MutationObserver(() => {
              checkAndHide();
          });

          observer.observe(button, { attributes: true, attributeFilter: ['class'] });

          // Initial check
          checkAndHide();
      }
  });
});


function updateContactLinks() {
    // Object to store the mappings of ids to their respective links
    var contactLinks = {
        "phone-us": "tel:+61294524981",
        "email-us": "/pages/contact-us",
        "live-chat": "" // Special case, handled separately
    };

    // Loop through each id in the contactLinks object
    for (var id in contactLinks) {
        // Find the element with the corresponding id
        var element = document.getElementById(id);

        // Handle phone-us and email-us normally
        if (element && contactLinks[id] !== "") {
            // Get the current text inside the element
            var text = element.textContent;

            // Create a new <a> element
            var linkElement = document.createElement("a");

            // Set the href attribute to the corresponding value
            linkElement.href = contactLinks[id];

            // Set the text inside the <a> tag to be the current text
            linkElement.textContent = text;

            // Clear the element's content and append the <a> link inside it
            element.innerHTML = '';
            element.appendChild(linkElement);
        }

        // Handle the live-chat element with the GorgiasChat functionality
        if (id === "live-chat" && element) {
            // Get the current text inside the element
            var text = element.textContent;

            // Create a new <a> element
            var chatLink = document.createElement("a");

            // Set the onclick attribute to open the Gorgias chat
            chatLink.setAttribute("onclick", "GorgiasChat.open();");

            // Set the text inside the <a> tag to be the current text
            chatLink.textContent = text || "Start a chat with our team"; // Default text if none exists

            // Clear the element's content and append the <a> link inside it
            element.innerHTML = '';
            element.appendChild(chatLink);
        }
    }
}

// Call the function to update the contact links
updateContactLinks();


